import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginView from "../views/UserLoginView";
import payment from "../views/RequestPayment.vue";
import Layout from '../components/layout/Layout.vue'
import clientsside from "../views/clientsside.vue"
import clientspart from "../views/clientspart.vue"
import Dashboard from "@/views/Dashboard.vue";
import Department from "@/views/DeptManager.vue";
import UserHistory from "../views/UserHistory.vue"
import wallet from "@/views/wallet.vue";
import UserRequests from "@/views/UserRequests.vue";
import Settings from "@/views/settings/Settings.vue";
import store from "../store/index"
import SelectRequest from "@/views/SelectRequest.vue"
import FundsRequest from "@/views/FundsRequest.vue"
import otp from "@/views/otp.vue";
import otpForm from "@/components/otpForm.vue";
Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'login',
            component: LoginView,
            meta: { title: "Login" },
        },
        {
            path: '/otp',
            name: 'otp',
            component: otpForm,
            meta: { title: "OTP" }
        },


        {
            path: '/',
            component: Layout,
            children: [
                {
                    path: '/request-payment',
                    name: 'RequestPayment',
                    component: payment,
                    meta: { title: "Request Payment" }
                },
                {
                    path: '/clientsside',
                    name: 'clientsside',
                    component: clientsside,
                    meta: { title: "Clients Side" }
                },
                {
                    path: '/Dashboard',
                    name: 'Dashboard',
                    component: Dashboard,
                    meta: { title: "Dashboard" }
                },
                {
                    path: '/DeptManager',
                    name: 'DeptManager',
                    component: Department,
                    meta: { title: "Manager Approvals" }
                },
                {
                    path: '/wallet',
                    name: 'wallet',
                    component: wallet,
                    meta: { title: "Wallet History" }
                },
                {
                    path: '/SelectRequest',
                    name: 'SelectRequest',
                    component: SelectRequest,
                    meta: { title: "Select Request" }
                },
                {
                    path: '/FundsRequest',
                    name: 'Funds',
                    component: FundsRequest,
                    meta: { title: "My Requests" }
                },
                {
                    path: '/clientspart',
                    name: 'clientspart',
                    component: clientspart,
                    meta: { title: "Clients Part" }
                },
                {
                    path: '/UserHistory',
                    name: 'UserHistory',
                    component: UserHistory,
                    meta: { title: "User History" }
                },
                {
                    path: '/UserRequests',
                    name: 'UserRequests',
                    component: UserRequests,
                    meta: { title: "User Requests" }
                },
                {
                    path: '/Settings',
                    name: 'settings',
                    component: Settings,
                    meta: { title: "Settings" }
                },

            ]
        },

    ]
});

router.beforeEach(async (to, from, next) => {
    // Skip routing to login if the user is already on the login page
    if (to.name === 'login' && localStorage.getItem('isLoggedIn')) {
        return next({ name: 'Funds' }); // Redirect to Dashboard if already logged in
    }

    // Protect routes that require login
    if (to.name !== 'login' && to.name !== 'otp') {
        const isLoggedIn = localStorage.getItem('isLoggedIn'); // Check the login flag from localStorage

        if (!isLoggedIn) {
            store.commit('setAttemptedRoute', to); // Store the attempted route to return to after login
            return next({ name: 'login' }); // Redirect to login if not logged in
        }
    }

    next();
});

// Track page views
router.afterEach((to, from) => {
    if (window.usageTracker) {
        window.usageTracker.track('petty-cash', {
            feature: 'page:' + (to.name || to.path),
            action: 'view'
        });
    }
});

// router.beforeEach(async (to, from, next) => {
//     if (!store.getters.isHydrated) {
//         await new Promise((resolve) => {
//             const interval = setInterval(() => {
//                 console.log(`is Hydrated`,store.getters.isHydrated)
//                 if (store.getters.isHydrated) {
//                     clearInterval(interval);
//                     resolve();
//                 }
//             }, 50);  // Check every 50ms
//         });
//     }
//     if (to.query.userInfo) {
//         let userInfo = JSON.parse(window.atob(to.query.userInfo));
//         return store.dispatch('validateUser', userInfo);
//     } else if (to.name !== 'login' && to.name !== 'OTP') {
//         let res = await authenticator.isUserLoggedIn()
//         if (!res) {
//             store.commit(`setAttemptedRoute`, to);
//             next({name: 'login'});
//         } else if (res && to.path === `/`) {
//             store.commit(`setAttemptedRoute`, to);
//             next({ name: 'login' })
//         } else {
//             next()
//         }
//     } else {
//         next()
//     }
// })
export default router
